import { PATH } from '~/constants/route-path';

export function isSidebarVisible(routePath) {
  if (routePath.includes('/s/')) return;

  return ![
    PATH.LOGIN,
    PATH.SIGN_UP,
    PATH.CONFIRMATION,
    PATH.PAYMENTS.CHECKOUT,
    PATH.UNAUTH.MAIN,
    PATH.UNAUTH.QRS_ON,
    PATH.UNAUTH.QRS_ON_DETAIL('menu'),
    PATH.PAYMENTS.SUCCESS,
    PATH.QR.LIMIT_REACHED,
    PATH.QR.NOT_FOUND,
    PATH.TOS,
    PATH.FACEBOOK_LOGIN,
    PATH.QR.DEACTIVATED,
    PATH.PAYMENTS.CANCEL_SUBSCRIPTION,
    PATH.UNAUTH.PRICES_AND_PLANS,
    PATH.UNAUTH.FAQ,
    PATH.UNAUTH.PRIVACY_POLICY,
    PATH.UNAUTH.DATA_DELETION,
    '/contact-us',
  ].includes(routePath);
}
